import { addAsync as _addAsync, getAsync as _getAsync } from "../api";

const BASE_URL = "/conversations";

export async function createAsync(data) {
    return _addAsync({ url: BASE_URL, data });
}

export async function readAsync({ sid }) {
    return _getAsync({ url: `${BASE_URL}/${sid}` });
}
